const OFFSET_TO_TZ_ABBR: Record<string, string> = {
	"-12:00": "AoE",
	"-11:00": "NUT",
	"-10:00": "HST",
	"-09:30": "MIT",
	"-09:00": "AKST",
	"-08:00": "PST",
	"-07:00": "MST",
	"-06:00": "CST",
	"-05:00": "EST",
	"-04:30": "VET",
	"-04:00": "AST",
	"-03:30": "NST",
	"-03:00": "BRT",
	"-02:00": "GST",
	"-01:00": "AZOT",
	"+00:00": "UTC",
	"+01:00": "CET",
	"+02:00": "EET",
	"+03:00": "MSK",
	"+03:30": "IRST",
	"+04:00": "GST",
	"+04:30": "AFT",
	"+05:00": "PKT",
	"+05:30": "IST",
	"+05:45": "NPT",
	"+06:00": "BST",
	"+06:30": "CCT",
	"+07:00": "WIB",
	"+08:00": "AWST",
	"+08:45": "CWST",
	"+09:00": "JST",
	"+09:30": "ACST",
	"+10:00": "AEST",
	"+10:30": "ACDT",
	"+11:00": "SBT",
	"+12:00": "NZST",
	"+12:45": "CHAST",
	"+13:00": "TOT",
	"+14:00": "LINT",
};

export function formatIsoWithOffset(
	isoString: string,
	locale = "en-AU"
): string | null {
	if (isoString === null || isoString === "" || isoString === undefined) {
		return null;
	}

	// parse the date
	const date = new Date(isoString);

	// extract offset from the string
	const match = isoString.match(/([+-]\d{2}:\d{2})$/);
	const offset = match ? match[1] : "+00:00"; // default to UTC

	// find abbreviation or fallback to offset
	const abbr = OFFSET_TO_TZ_ABBR[offset] ?? offset;

	// format the date/time fields
	const formatted = new Intl.DateTimeFormat(locale, {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
	}).format(date);

	return `${formatted} ${abbr}`;
}
